const React = require('react');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const trim = require('mn-utils/trim');
const onEnterProvider = require('mn-utils/onEnterProvider');
const isInvalidStringLength = require('mn-utils/isInvalidStringLength');
const Visibility = require('@material-ui/icons/Visibility').default;
const VisibilityOff = require('@material-ui/icons/VisibilityOff').default;
const CachedIcon = require('@material-ui/icons/Cached').default;
const IconButton = require('@material-ui/core/IconButton').default;
const {
  LINK_DASHBOARD,
  LINK_SIGN_IN,
} = require('../../../../constants/links');
const withState = require('../../../../utils/withState');
const {
  Link,
  replaceLocation,
} = require('../../../../router');
const validatePassword = require('../../../../utils/validatePassword');
const {
  decorateReconnect,
  apiAuthPasswordRecovery,
} = require('../../../../api/_auth');
const {
  openPopupWindow,
} = require('../../../../emitters/popup');
const {
  account$,
} = require('../../../../emitters/account');
const TextField = require('../../../dumb/TextField/I');
const Ripple = require('../../../dumb/Ripple');
const ButtonG = require('../../../dumb/Button/G');
const Base = require('./components/Base');


const sendRecoveryToken = decorateReconnect(apiAuthPasswordRecovery);


function openChangedPassword() {
  openPopupWindow((setPopupState, popup) => {
    popup.className = 'bg181A1C.95*2';

    return (stateOfPopup) => {
      return (
        <div className="rlv cF">
          <div className="mb30">
            <CachedIcon
              className="dB-i f46-i cF mhA"
            />
          </div>
          <div className="mt30 f16 fw5 tc lh160%">
            Your password has been changed
          </div>
          <div className="mt40">
            <ButtonG
              className="w160 h48*2 mhA"
              onClick={popup.close}
            >OK</ButtonG>
          </div>
        </div>
      );
    };
  });
}

module.exports = withState((setState) => {
  const changeProvider = changeProviderProvider(setState);
  const handleChangePassword = changeProvider('password');
  const handleChangeRecoveryToken = changeProvider('recoveryToken');
  const handleRecoveryTokenEnter = onEnterProvider(() => {
    _recoveryTokenNode && _recoveryTokenNode.focus();
  });

  let _passwordNode;
  let _recoveryTokenNode;

  function handlePasswordRef(node) {
    node && (_passwordNode = node);
  }

  function handleRecoveryTokenRef(node) {
    node && (_recoveryTokenNode = node);
  }

  return (state, props) => {
    const params = props.params || {};
    const clicked = state.clicked || false;
    const showPassword = state.showPassword || false;

    let recoveryToken = state.recoveryToken;
    recoveryToken === undefined && (recoveryToken = params.token || '');
    const _recoveryToken = trim(recoveryToken);

    const password = state.password || '';
    const invalidPasswordChars = !validatePassword(password);
    const invalidPasswordLength = isInvalidStringLength(password, 8);
    const invalidPasswordWeak = !validatePassword.week(password);
    const invalidPassword = invalidPasswordChars
      || invalidPasswordLength
      || invalidPasswordWeak;

    const invalidRecoveryToken = !_recoveryToken;

    const disabled = invalidPassword
      || invalidRecoveryToken;

    const VisibilityIcon = showPassword
      ? VisibilityOff
      : Visibility;

    function handleSubmit() {
      _passwordNode && _passwordNode.blur();
      if (disabled) {
        setState({
          clicked: true,
        });
        return;
      }
      setState({
        loading: true,
      });
      sendRecoveryToken({
        token: _recoveryToken,
        password,
      }).finally((error) => {
        error || (
          replaceLocation({
            path: LINK_SIGN_IN,
          }),
          openChangedPassword()
        );
        setState({
          loading: false,
        });
      });
    }

    state.account && replaceLocation({
      path: LINK_DASHBOARD,
    });

    return (
      <Base
        title="Recovery password"
        description="Set a new password"
        content={(<>
          <TextField
            label="Recovery token"
            value={recoveryToken}
            onChange={handleChangeRecoveryToken}
            onKeyPress={handleRecoveryTokenEnter}
            inputRef={handleRecoveryTokenRef}
            error={clicked && invalidRecoveryToken}
            helperText="Obligatory field"
            autoComplete="new-password"
          />
          <TextField
            className="mt20"
            type={showPassword ? 'text' : 'password'}
            label="Password"
            value={password}
            error={clicked && invalidPassword}
            helperText={
              invalidPasswordChars
                ? 'Password must contain Latin letters, numbers and symbols'
                : (
                  invalidPasswordLength
                    ? 'Password must contain at least 8 characters'
                    : 'Password too weak'
                )
            }
            onChange={handleChangePassword}
            onKeyPress={onEnterProvider(handleSubmit)}
            inputRef={handlePasswordRef}
            InputProps={{
              endAdornment: (
                <IconButton
                  className="rlv sl10 mv-5*2"
                  aria-label="Toggle password visibility"
                  onClick={() => {
                    setState({
                      showPassword: !showPassword,
                    });
                  }}
                >
                  <VisibilityIcon className="c0C"/>
                </IconButton>
              ),
            }}
            autoComplete="new-password"
          />
        </>)}
        beforeFooter={(
          <div className="ph25 pt15 pb35 lh18 lts0em">
            <Link
              href={LINK_SIGN_IN}
              className="c5B47FF olN tdU dn f12 fw3 o70:h"
            >I have a password</Link>
          </div>
        )}
        control={(
          <Ripple
            className="layoutRow fhaC fvaC wmin270 ph15
            h60 f16 lh21 r3 cF ttU tdN olN usN b0 dn bg5B47FF
            bg4B37EF:not[.disabled]:h o50.disabled"
            disabled={clicked && disabled}
            onClick={handleSubmit}
          >Set password</Ripple>
        )}
      />
    );
  };
}, {
  account: account$,
});
